/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-card[_ngcontent-%COMP%]{width:300px;height:200px;margin:40px;float:left}mat-card-content[_ngcontent-%COMP%]{padding-top:20px}table[_ngcontent-%COMP%]{margin-bottom:20px}.subscribers[_ngcontent-%COMP%]{display:flex;margin-bottom:20px}.subscribers__first-name[_ngcontent-%COMP%]{flex:1}.subscribers__confirmed-date[_ngcontent-%COMP%]{flex:1;text-align:right}"];
export { styles as styles };
